import styled from 'styled-components';
import { rem } from 'polished';
import theme from '../../styles/theme';

const StepWrapper = styled.div`
  display: flex;

  .left-column {
    .number-content {
      background: ${theme.background.blue};
      border-radius: 50%;
      color: ${theme.textColor.white};
      height: ${rem('28px')};
      width: ${rem('28px')};
      font-size: ${rem('16px')};
      justify-content: center;
      align-items: center;
      display: flex;
      margin: ${`${rem('2px')} ${rem('10px')} 0 0`};
    }
  }
  .right-column {

  }
`;
StepWrapper.displayName = 'StepWrapper';

export default StepWrapper;
